import { ArrowRight } from 'lucide-react'

const UPSELL_ITEMS = [
  { isAvailable: false, label: 'Sélection de sièges supplémentaires' },
  { isAvailable: false, label: 'Location de voiture' },
  { isAvailable: false, label: 'Réservation de siège' },
  { isAvailable: false, label: 'Assurance voyage' },
  { isAvailable: false, label: 'Réserver un hôtel ou logement' },
  { isAvailable: false, label: 'Ajouter des bagages supplémentaires' },
  { isAvailable: false, label: 'Choix de repas à bord' },
  {
    isAvailable: false,
    label: 'Embarquement prioritaire et livraison bagages rapide',
  },
] as const

export function CompleteYourTripSection() {
  return (
    <div className="border-gray-light-200 flex flex-col gap-7 rounded-2xl border bg-white p-6">
      <div className="text-gray-light-900 text-lg leading-7 font-semibold sm:text-2xl">
        Compléter votre voyage !
      </div>

      <div className="flex flex-col gap-3">
        {UPSELL_ITEMS.map((item, i) => (
          <div
            key={i}
            className={`flex items-center justify-between pb-4 ${
              i < UPSELL_ITEMS.length - 1 ? 'border-gray-light-200 border-b' : ''
            }`}
          >
            <div className="flex items-center gap-3">
              <div
                className={`size-4 shrink-0 ${item.isAvailable ? 'bg-brand-700' : 'bg-gray-light-200'}`}
              />
              <span
                className={`text-sm leading-5 font-semibold sm:text-base ${
                  item.isAvailable ? 'text-brand-700' : 'text-gray-light-900'
                }`}
              >
                {item.label}
              </span>
            </div>
            {item.isAvailable ? (
              <ArrowRight className="text-gray-light-600 size-6 shrink-0" />
            ) : (
              <span className="bg-gray-light-200 text-gray-light-900 rounded-full px-2 py-1 text-xs font-semibold">
                Bientôt disponible
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
